import { Price } from "flicket-ui";

export interface IPriceWithFee {
  price: number;
  showFees: boolean;
  isPercentage?: boolean;
  isSoldOut?: boolean;
  fee?: number;
  stadiumLevyFee?: number;
}

const PriceWithFee = ({
  price,
  showFees = false,
  isPercentage = false,
  isSoldOut = false,
  fee = 0,
  stadiumLevyFee = 0,
}: IPriceWithFee) => {
  if (!price) return <>Free</>;

  if (isSoldOut) return <>Sold out</>;

  if (!showFees || (fee <= 0 && stadiumLevyFee <= 0)) {
    return <Price price={price} />;
  }

  const FeeComponent = ((price: number) => {
    const Component = isPercentage ? (
      <Price price={price * (fee / 100) + stadiumLevyFee} />
    ) : (
      <Price price={fee + stadiumLevyFee} />
    );

    return <>{Component} Fees</>;
  })(price);

  return (
    <>
      <Price price={price} /> {"\u002B"} {FeeComponent}
    </>
  );
};

export default PriceWithFee;
